import { transformKeysToCamelCase } from 'shared/functions';

const parseSettingData = ({ type, ...data }) => {
  return {
    ...data,
    ...type,
  };
};
export const parseSettingsData = data =>
  data
    .map(item => transformKeysToCamelCase(item))
    .reduce((all, current) => {
      return {
        ...all,
        [current.type.category]: all[current.type.category]
          ? [...all[current.type.category], parseSettingData(current)]
          : [parseSettingData(current)],
      };
    }, {});
export const parseSettingsDataToUpdate = data =>
  data.map(({ type: { tag }, _id, ...settings }) => ({
    ...settings,
    type_tag: tag,
  }));
